module.exports = __webpack_public_path__ + "img/12_19.0371ab40.png";